/**
 * Variant product gallery — swaps main slides + thumbs when variant changes.
 * Only runs on products with data-variant-galleries="true".
 */
(function() {
  'use strict';

  var thumbFlktyMap = new WeakMap();

  function getProductInstance(section) {
    if (!window.theme || !theme.sections || !theme.sections.instances) return null;
    var sectionId = section.getAttribute('data-section-id');
    for (var i = 0; i < theme.sections.instances.length; i++) {
      if (theme.sections.instances[i].id === sectionId) {
        return theme.sections.instances[i];
      }
    }
    return null;
  }

  function findGalleryTemplate(templatesRoot, variantId) {
    var custom = templatesRoot.querySelector(
      '[data-variant-gallery-template][data-has-custom="true"][data-variant-id="' + variantId + '"]'
    );
    if (custom) return custom;
    return templatesRoot.querySelector('[data-variant-gallery-template][data-variant-id="default"]');
  }

  function destroyThumbScroller(scroller) {
    if (!scroller || typeof Flickity === 'undefined') return;
    var flkty = Flickity.data(scroller);
    if (flkty) {
      flkty.destroy();
      thumbFlktyMap.delete(scroller);
    }
  }

  function initThumbScroller(scroller, mainSliderEl) {
    if (!scroller || typeof Flickity === 'undefined') return;

    destroyThumbScroller(scroller);

    var totalThumbs = scroller.querySelectorAll('.product__thumb-item').length;
    if (totalThumbs === 0) return;

    var thumbFlkty = new Flickity(scroller, {
      cellSelector: '.product__thumb-item',
      contain: true,
      pageDots: false,
      draggable: totalThumbs > 4,
      prevNextButtons: totalThumbs > 4,
      freeScroll: false,
      wrapAround: false
    });

    thumbFlktyMap.set(scroller, thumbFlkty);

    if (!mainSliderEl) return;
    var mainFlkty = Flickity.data(mainSliderEl);
    if (!mainFlkty) return;

    mainFlkty.on('change', function(index) {
      scroller.querySelectorAll('.product__thumb').forEach(function(el) {
        el.classList.remove('is-active');
      });
      var activeThumb = scroller.querySelector('.product__thumb[data-index="' + index + '"]');
      if (activeThumb) {
        activeThumb.classList.add('is-active');
      }
      thumbFlkty.select(index);
    });
  }

  function toggleThumbsVisibility(thumbsContainer, slideCount) {
    if (!thumbsContainer) return;
    if (slideCount <= 1) {
      thumbsContainer.classList.add('medium-up--hide');
    } else {
      thumbsContainer.classList.remove('medium-up--hide');
    }
  }

  function reinitGallery(section, imagesRoot) {
    var product = getProductInstance(section);
    if (!product) return;

    product.settings.currentSlideIndex = 0;
    product.firstProductImage = product.mainSlider.querySelector('img');

    if (product.flickity) {
      product.destroyImageCarousels();
    }

    product.initProductSlider();

    if (product.flickity) {
      product.flickity.goToSlide(0);
    }

    var scroller = imagesRoot.querySelector('[data-product-thumbs-scroller]');
    var mainSliderEl = imagesRoot.querySelector('[data-product-photos]');
    initThumbScroller(scroller, mainSliderEl);
  }

  function getProductSection(evt) {
    if (evt.target && typeof evt.target.closest === 'function') {
      var fromTarget = evt.target.closest('[data-section-type="product-template"]');
      if (fromTarget) return fromTarget;
    }

    var imagesRoot = document.querySelector('[data-product-images][data-variant-galleries="true"]');
    if (imagesRoot) {
      return imagesRoot.closest('[data-section-type="product-template"]');
    }

    return document.querySelector('[data-section-type="product-template"]');
  }

  var lastHandledVariantId = null;
  var lastHandledAt = 0;

  function handleVariantChange(evt) {
    var variant = evt.detail && evt.detail.variant;
    if (!variant) return;

    var variantId = String(variant.id);
    var now = Date.now();
    if (variantId === lastHandledVariantId && now - lastHandledAt < 50) return;
    lastHandledVariantId = variantId;
    lastHandledAt = now;

    var section = getProductSection(evt);
    if (!section) return;

    var imagesRoot = section.querySelector('[data-product-images][data-variant-galleries="true"]');
    if (!imagesRoot) return;

    var templatesRoot = section.querySelector('[data-variant-gallery-templates]');
    if (!templatesRoot) return;

    var template = findGalleryTemplate(templatesRoot, variantId);
    if (!template || !template.content) return;

    var slidesSource = template.content.querySelector('[data-variant-gallery-slides]');
    var thumbsSource = template.content.querySelector('[data-variant-gallery-thumbs]');
    if (!slidesSource) return;

    var mainPhotos = imagesRoot.querySelector('[data-product-photos]');
    var thumbScroller = imagesRoot.querySelector('[data-product-thumbs-scroller]');
    var thumbsContainer = imagesRoot.querySelector('[data-product-thumbs]');

    if (!mainPhotos) return;

    var product = getProductInstance(section);
    if (product && product.flickity) {
      product.destroyImageCarousels();
    }

    destroyThumbScroller(thumbScroller);

    mainPhotos.innerHTML = slidesSource.innerHTML;

    if (thumbScroller && thumbsSource) {
      thumbScroller.innerHTML = thumbsSource.innerHTML;
    }

    var slideCount = mainPhotos.querySelectorAll('.product-main-slide').length;
    var hasCustom = template.getAttribute('data-has-custom') === 'true';
    imagesRoot.setAttribute('data-custom-gallery-active', hasCustom ? 'true' : 'false');

    toggleThumbsVisibility(thumbsContainer, slideCount);

    requestAnimationFrame(function() {
      reinitGallery(section, imagesRoot);
    });
  }

  // variantChange is dispatched on the section container (does not bubble)
  document.addEventListener('variantChange', handleVariantChange, true);
  // theme.js also dispatches variant:change on document
  document.addEventListener('variant:change', handleVariantChange);
})();
